import { useQuery } from 'react-query';
import axios from '../../../api';

// GET request to retrieve the preview details (surveys) for a given wevoId

const getPreviewSurveys = async ({ queryKey: [key, { wevoId }] }) => {
  const response = await axios({
    url: `/api/v3/wevos/${wevoId}/previews`,
    method: 'GET',
  });
  return response?.data;
};

export default function useGetPreviewSurveys({ wevoId }, options) {
  return useQuery(['previewSurveys', { wevoId }], getPreviewSurveys, options);
}
